// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1qMVv","errors":"Errors_errors__2Gcq-"};